import { HttpClient } from "@angular/common/http";
import { APP_CONFIG, IAppConfig } from "../../../app.config";
import { Inject, Injectable } from "@angular/core";
import { NotificationKind } from "../../model/const/enum";
import { catchError, finalize, Observable } from "rxjs";
import { MessageService } from "../../../core/service/message.service";
import { ProgressBarService } from "../../../core/service/progress-bar.service";

@Injectable()
export class NotificationSettingService {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    private _messageService: MessageService,
    private _progressBar: ProgressBarService) {
      this._endpoint = `${config.apiEndpointV2}/notification-setting`;
    }

  private _endpoint: string;

  change(settings: NotificationKind[]): Observable<void> {
    return this._client.put<void>(this._endpoint, JSON.stringify(settings)).pipe(
      catchError(error => {
        this._messageService.showError(error);
        return [];
      }),
      finalize(() => this._progressBar.stop())
    );
  }

  get(): Observable<NotificationKind[]> {
    return this._client.get<NotificationKind[]>(this._endpoint).pipe(
      catchError(error => {
        this._messageService.showError(error);
        return [];
      }),
      finalize(() => this._progressBar.stop())
    );
  }
}